import { render } from "./Uitvaartverzekering.vue?vue&type=template&id=b237ff5a"
import script from "./Uitvaartverzekering.vue?vue&type=script&lang=js"
export * from "./Uitvaartverzekering.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__